<template>
  <div>
    <div v-if="projectDetail.project_info.exami_type === '公务员录聘'">
      <div class="bkxx-wrap">
        <div class="bkxx-card">
          <div class="card-header">
            <span class="card-title">请选择报考职位</span>
            <span class="card-tip">温馨提示：输入职位（岗位）代码后，系统自动查询对应职位信息</span>
          </div>
          <div class="card-body">
            <el-form label-width="120px" size="small">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="请选择考试地区">
                    <el-cascader v-model="selectOne" :options="area_one_list" :props="props" style="width:100%"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="请选择报名地市">
                    <el-cascader v-model="selectTwo" :options="area_two_list" :props="props" style="width:100%"></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="职位（岗位）代码">
                    <el-input v-model="pisitionId" placeholder="请输入职位代码" @keyup.enter.native="registerPosition">
                      <el-button slot="append" type="primary" @click="registerPosition">查询</el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="positionModel">
                <el-col :span="12">
                  <el-form-item label="单位名称">
                    <el-input :value="positionModel.company" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="职位名称">
                    <el-input :value="positionModel.title" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="bkxx-card" v-if="positionModel">
          <div class="card-header"><span class="card-title">职位条件</span><span class="card-tip">（详细内容阅读招考公告）</span></div>
          <div class="card-body">
            <el-descriptions :column="3" border size="small">
              <el-descriptions-item label="岗位咨询电话">{{ positionModel.section_tel }}</el-descriptions-item>
              <el-descriptions-item label="招考人数">{{ positionModel.num }}人</el-descriptions-item>
              <el-descriptions-item label="招考比例">{{ positionModel.percent }}</el-descriptions-item>
            </el-descriptions>
            <el-table :data="conditionList" style="width:100%;margin-top:16px;" size="small" border v-if="conditionList.length">
              <el-table-column prop="field_title" label="指标"></el-table-column>
              <el-table-column label="要求" width="120">
                <template #default="scope">{{ operatorText(scope.row.operator) }}</template>
              </el-table-column>
              <el-table-column label="指标值">
                <template #default="scope">{{ scope.row.value_text || scope.row.value }}</template>
              </el-table-column>
              <el-table-column prop="label" label="说明"></el-table-column>
            </el-table>
            <div style="margin-top:12px;font-size:14px;color:#606266;" v-if="positionModel.other">
              <span>其他条件：</span><span style="color:#303133;">{{ positionModel.other }}</span>
            </div>
          </div>
        </div>
        <div class="bkxx-card" v-if="positionModel">
          <div class="card-header"><span class="card-title">考试科目</span></div>
          <div class="card-body">
            <el-table :data="tableDetail" style="width:100%" size="small" border>
              <el-table-column width="60" align="center" label="选择">
                <template #default="scope">
                  <el-checkbox :disabled="scope.row.disabled" v-model="tableDetail[scope.$index].check"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="科目"></el-table-column>
              <el-table-column prop="money" label="费用" width="120"></el-table-column>
            </el-table>
          </div>
        </div>
        <div v-if="!positionModel" class="bkxx-card"><div class="card-body empty-tip">请先输入职位代码并查询</div></div>
        <div class="bkxx-submit"><el-button type="primary" size="medium" @click="checkBkxx()">确认提交</el-button></div>
      </div>
    </div>
    <div v-if="projectDetail.project_info.exami_type === '研究生招生考试'">
      <div class="bkxx-wrap"><div class="bkxx-card"><div class="card-body" style="width:80%;margin:0 auto;">
        <form-create v-model="fApi" :rule="fRule" :option="option"></form-create>
      </div></div></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { registeredPosition, reqProjectSavedata, reqProjectDetail } from "@/api";
export default {
  data() {
    return {
      props: { multiple: false },
      selectOne: "", selectTwo: "", pisitionId: "",
      positionModel: null, tableDetail: [],
      major_id: "", grade_id: "",
      fApi: {},
      option: {
        resetBtn: false,
        submitBtn: { innerText: "确认提交", show: true },
        global: { upload: { handleIcon: "ios-eye-outline", allowRemove: true } },
        onSubmit: (formData) => {
          if (this.process.enable == 0) { this.$message.error("当前状态无法提交更改"); return false; }
          let formobj = this.fApi.formData();
          formobj.project_id = this.$parent.projectDetail.project_info.id;
          reqProjectSavedata(formobj).then((res) => {
            if (res.data.code === 1) {
              reqProjectDetail({ project_id: this.$parent.projectDetail.project_info.id, step_name: "bkxx" }).then((r) => {
                if (r.data.code === 1) { this.changeProject(r.data.data); this.$parent.next(); }
                else { this.$parent.next(); this.$message.success("资料已保存"); }
              });
            } else { this.$message.error(res.data.msg); }
          });
        },
      },
    };
  },
  props: {
    process_index: 0,
    process: { type: Object, default() { return []; } },
  },
  computed: {
    ...mapState(useMainStore, { projectDetail: "getProjectDetail" }),
    fRule() {
      return this.process && this.process.content && this.process.content.field_list ? this.process.content.field_list : [];
    },
    area_one_list() {
      if (this.projectDetail && this.projectDetail.project_info && this.projectDetail.project_info.exami_type == "公务员录聘") {
        if (this.process && this.process.content && this.process.content.area_list && this.process.content.area_list.area_list) {
          return this.process.content.area_list.area_list.map((i) => ({ value: i.id, label: i.city }));
        }
      }
      return [];
    },
    area_two_list() {
      if (this.projectDetail && this.projectDetail.project_info && this.projectDetail.project_info.exami_type == "公务员录聘" && this.process && this.process.content && this.process.content.area_list) {
        let arr = [];
        let curAreaId = Array.isArray(this.selectOne) ? this.selectOne[0] : this.selectOne;
        this.process.content.area_list.area_list.forEach((item) => {
          if (curAreaId == item.id) {
            let pt = item.point || item.Point;
            if (pt) {
              if (Array.isArray(pt)) {
                arr = pt.map((p) => ({ value: p.id, label: p.city }));
              } else {
                arr = [{ value: pt.id, label: pt.city }];
              }
            }
          }
        });
        return arr;
      }
      return [];
    },
    conditionList() {
      if (!this.positionModel) return [];
      var raw = this.positionModel.condition_json || this.positionModel.fieldlist_json;
      if (!raw) return [];
      try {
        var list = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(list) ? list : [];
      } catch (e) { return []; }
    },
  },
  methods: {
    operatorText(op) {
      return { '=': '等于', '!=': '不等于', '>': '大于', '<': '小于', '>=': '大于等于', '<=': '小于等于' }[op] || op;
    },
    registerPosition() {
      registeredPosition({ position_code: this.pisitionId }).then((res) => {
        if (res.data.code === 1) {
          this.positionModel = res.data.data;
          this.tableDetail = (res.data.data.subject_list || []).map((item) => ({
            check: item.is_must == 1, disabled: item.is_must == 1, ...item,
          }));
          this.grade_id = res.data.data.grade_id;
          this.major_id = res.data.data.major_id;
        }
      });
    },
    checkBkxx() {
      if (this.$parent.projectDetail.current_step != this.process_index) {
        this.$message.error("当前状态无法提交更改"); return false;
      }
      if (!this.selectOne) return this.$message("请选择报考地区");
      if (!this.selectTwo) return this.$message("请选择报考地市");
      if (!this.pisitionId) return this.$message("请输入职位代码");
      if (this.pisitionId && !this.grade_id) return this.$message("请确认职位代码是否正确，并且点击查询");
      let checkIds = [];
      this.tableDetail.forEach((item) => { if (item.check) checkIds.push(item.id); });
      reqProjectSavedata({
        area_id: this.selectOne[0], point_id: this.selectTwo[0],
        grade_id: this.grade_id, major_id: this.major_id,
        subject_ids: checkIds, project_id: this.$parent.projectDetail.project_info.id,
        position_id: this.positionModel.id,
      }).then((res) => {
        if (res.data.code === 1) {
          reqProjectDetail({ project_id: this.$parent.projectDetail.project_info.id, step_name: "bkxx" }).then((r) => {
            if (r.data.code === 1) this.changeProject(r.data.data);
            this.$parent.next();
          }).catch(() => {
            this.$parent.next();
          });
        } else { this.$message.error(res.data.msg); }
      });
    },
    ...mapActions(useMainStore, { changeProject: "updateProjectDetail" }),
  },
  mounted() {},
};
</script>

<style scoped>
.bkxx-wrap { max-width: 900px; margin: 20px auto; }
.bkxx-card { background: #fff; border: 1px solid #e8e8e8; border-radius: 6px; margin-bottom: 16px; }
.card-header { padding: 12px 20px; border-bottom: 1px solid #e8e8e8; display: flex; align-items: center; }
.card-title { font-size: 15px; font-weight: 600; color: #303133; }
.card-tip { font-size: 13px; color: #909399; margin-left: 12px; }
.card-body { padding: 20px; }
.empty-tip { text-align: center; color: #999; padding: 40px 0; }
.bkxx-submit { text-align: center; padding: 20px 0; }
</style>
